import {
	ChangeDetectionStrategy,
	Component,
	Input,
	ViewEncapsulation
} from '@angular/core';
import { ReportOverviewItem } from '@models/admin/reports.model';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { GeneralAction, IModalAction } from '@models/models';
import { SNModalService } from '@web-services/modal/snModal.service';
import { GenerateReportModalComponent } from '@web-components/admin/report/generate-modal/generate-report.modal';
import { Subscription } from 'rxjs/Subscription';
import { FileDownloadDataServiceProvider } from '@services/files/file-download-service/file-download.data.service';
import { MessageService } from '@services/helpers/message-service/message.service';
import { finalize } from 'rxjs/operators';
import { ReportsOverviewDataProvider } from '@services/admin/reports/reports-overview.data.service';

@Component({
	selector: 'report-overview-item',
	template: require('./report-overview-item.component.html'),
	styles: [require('./report-overview-item.component.scss')],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportOverviewItemComponent {
	@Input('item') reportOverviewItem: ReportOverviewItem;

	private generateReportModalRef: NgbModalRef;
	modalDataSubscription: Subscription;

	constructor(
		private modalService: SNModalService,
		private fileDownloadService: FileDownloadDataServiceProvider,
		private reportsOverviewService: ReportsOverviewDataProvider,
		private messageService: MessageService
	) {}

	openModal(action: GeneralAction, name: string) {
		this.generateReportModalRef = this.modalService.openModal(
			GenerateReportModalComponent,
			{
				windowClass: 'ng-bootstrap-modal__small'
			}
		);

		this.generateReportModalRef.result.then((): void =>
			this.modalDataSubscription.unsubscribe()
		);

		this.modalDataSubscription = this.modalService
			.getModalData()
			.subscribe((data: IModalAction<any>) =>
				// call function
				this[name](data)
			);

		this.generateReportModalRef.componentInstance.reportOverviewItem = this.reportOverviewItem;
		this.generateReportModalRef.componentInstance.action = action;
	}

	// don't rename. used in html
	private downloadReportFile(data: IModalAction<any>): void {
		this.generateReportModalRef.componentInstance.btnDisabled = true;
		this.fileDownloadService
			.downloadFileDynamic(
				this.generateReportModalRef.componentInstance.action,
				{
					params: data
				}
			)
			.pipe(
				finalize((): void => {
					this.generateReportModalRef.componentInstance.btnDisabled = false;
				})
			)
			.subscribe(
				(): void => {
					this.messageService.showToaster('s_4', 'admin');

					this.modalDataSubscription.unsubscribe();
					this.generateReportModalRef.close();
				},
				({ error }): void => {
					const { errorMessage, errorTitle } = error;
					this.messageService.showErrorFromBackend(errorTitle, errorMessage);
				}
			);
	}

	// don't rename. used in html
	private doUpdateData(data: IModalAction<any>): void {
		this.generateReportModalRef.componentInstance.btnDisabled = true;
		this.reportsOverviewService
			.updateData(this.generateReportModalRef.componentInstance.action, {
				params: data
			})
			.pipe(
				finalize((): void => {
					this.generateReportModalRef.componentInstance.btnDisabled = false;
				})
			)
			.subscribe((data: any): void => {
				this.messageService.showToaster('s_5', 'admin');

				this.modalDataSubscription.unsubscribe();
				this.generateReportModalRef.close();
			});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/admin/report/overview-item/report-overview-item.component.ts